<div
  class="adf-property-label"
  [attr.data-automation-id]="'card-dateitem-label-' + property.key"
  *ngIf="showProperty || isEditable"
>
  {{ property.label | translate }}
</div>

<div class="adf-property-value adf-property-value-padding-top">
  <span
    *ngIf="!isEditable"
    [attr.data-automation-id]="
      'card-' + property.type + '-value-' + property.key
    "
  >
    <span [attr.data-automation-id]="'card-dateitem-' + property.key">
      <span
        *ngIf="showProperty"
        (dblclick)="copyToClipboard(property.displayValue)"
        matTooltipShowDelay="1000"
        [title]="'CORE.METADATA.ACTIONS.COPY_TO_CLIPBOARD' | translate"
        >{{ valueDate | date : 'short' }}</span
      >
    </span>
  </span>
  <div *ngIf="isEditable" class="adf-dateitem-editable">
    <div class="adf-dateitem-editable-controls">
      <span
        class="adf-datepicker-toggle"
        [attr.data-automation-id]="'datepicker-label-toggle-' + property.key"
        (click)="showDatePicker()"
        (keyup)="showDatePicker()"
      >
        <span
          *ngIf="showProperty; else elseEmptyValueBlock"
          [attr.data-automation-id]="
            'card-' + property.type + '-value-' + property.key
          "
          >{{ valueDate | date : 'short' }}</span
        >
      </span>

      <mat-icon
        *ngIf="showClearAction"
        class="adf-date-reset-icon"
        (click)="onDateClear()"
        (keyup)="onDateClear()"
        [attr.title]="'CORE.METADATA.ACTIONS.CLEAR' | translate"
        [attr.data-automation-id]="'datepicker-date-clear-' + property.key"
      >
        clear
      </mat-icon>

      <mat-datetimepicker-toggle
        [attr.tabindex]="-1"
        [attr.title]="'CORE.METADATA.ACTIONS.EDIT' | translate"
        [attr.data-automation-id]="'datepickertoggle-' + property.key"
        [for]="datetimePicker"
      >
      </mat-datetimepicker-toggle>
    </div>

    <input
      class="adf-invisible-date-input"
      [attr.tabIndex]="-1"
      [matDatetimepicker]="datetimePicker"
      [value]="valueDate"
      (dateChange)="onDateChanged($event)"
    />

    <mat-datetimepicker
      #datetimePicker
      [type]="dateTypeSelector"
      [timeInterval]="datePickerInterval"
      [attr.data-automation-id]="'datepicker-' + property.key"
      [startAt]="valueDate"
    >
    </mat-datetimepicker>
  </div>
  <ng-template #elseEmptyValueBlock>
    {{ property.default | translate }}
  </ng-template>
</div>
